import request from '@/utils/http';

// 地址解析 - 根据详细地址返回省市区镇、经纬度信息
export const addressGeocoding = address => {
    return request({
        url: `/anapi-oms/searchagg/gis/searchByAddress`,
        method: 'post',
        data: address
    });
};

// 使用发车单号查询发车单信息
export const getDispatchInfo = dispatchNo => {
    return request({
        url: `/api-antms/transport/dispatch/query/dispatchNo?dispatchNo=${dispatchNo}`,
        method: 'get'
    });
};

// 使用发车单号查询链路信息
export const queryDispatchStatusRoute = data => {
    return request({
        url: `/api-antms/transport/dispatch/queryDispatchStatusRoute?dispatchNo=${data}`,
        method: 'get'
    });
};

// 使用发车单号查询基础信息
export const queryDispatchBasicInfo = data => {
    return request({
        url: `/api-antms/transport/dispatch/query/dispatchNo?dispatchNo=${data}`,
        method: 'get'
    });
};

// 使用发车单号查询站点信息
export const queryDispatchTransports = data => {
    return request({
        url: `/api-antms/transport/dispatch/queryDispatchDetailList?dispatchNo=${data}`,
        method: 'get'
    });
};

// 使用发车单号查询任务信息
export const queryDispatchTaskList = data => {
    return request({
        url: `/api-antms/transport/dispatch/queryTask?dispatchNo=${data}`,
        method: 'get'
    });
};

// 到车登记附件查询接口
export const queryArrivalAttachment = data => {
    return request({
        url: `/api-antms/transport/attachment/list`,
        method: 'get',
        params: data
    });
};

// 使用发车单号查询里程明细
export const queryLichengRecord = data => {
    return request({
        url: `/api-tms/dispatch/lichengRecord/search/${data}`,
        method: 'get'
    });
};
// 发车单手动抵达
export const updatehandlearrivedcust = data => {
    return request({
        url: `/api-antms/receipt/dispatch/updatehandlearrivedcust`,
        method: 'post',
        data
    });
};
// 发车单手动取消运抵
export const cancleArrivalConfirm = data => {
    return request({
        url: `/api-antms/receipt/dispatch/cancleArrivalConfirm`,
        method: 'post',
        data
    });
};
// 手动到车
export const updatearrive = data => {
    return request({
        url: `/api-antms/transport/dispatch/updatearrive`,
        method: 'post',
        data
    });
};
// 取消到车
export const cancelarrive = data => {
    return request({
        url: `/api-antms/transport/dispatch/cancelarrive`,
        method: 'post',
        data
    });
};
// 到车附件上传
export const attAchment = data => {
    return request({
        url: `/api-antms/transport/attachment/add`,
        method: 'post',
        data
    });
};
// 到车附件列表
export const getAchmentPage = data => {
    return request({
        url: `/api-antms/transport/attachment/page`,
        method: 'post',
        data
    });
};
// 到车附件删除
export const attachmentDelete = id => {
    return request({
        url: `/api-antms/transport/attachment/delete?id=${id}`,
        method: 'get'
    });
};
// 发车单列表接口
export const queryByPage = data => {
    return request({
        url: `/api-antms/query/dispatch/queryByPage`,
        method: 'post',
        data
    });
};
// 发车单管理-列表分页统计数量
export const queryCount = data => {
    return request({
        url: `/api-antms/query/dispatch/queryCount`,
        method: 'post',
        data
    });
};
// 手动发车
export const updatedepart = data => {
    return request({
        url: `/api-antms/transport/dispatch/updatedepart`,
        method: 'post',
        data
    });
};
// 到车明细
export const quereyArrivalRegistration = data => {
    return request({
        url: `/api-antms/transport/dispatch/quereyArrivalRegistration`,
        method: 'post',
        data
    });
};
// 取消到车明细
export const quereyCancelArrivalRegistration = data => {
    return request({
        url: `/api-antms/transport/dispatch/quereyCancelArrivalRegistration`,
        method: 'post',
        data
    });
};

// 运抵明细
export const quereyArrivalConfirm = data => {
    return request({
        url: `/api-antms/transport/dispatch/quereyArrivalConfirm`,
        method: 'post',
        data
    });
};

// 取消运抵
export const updatecancelarrivedcust = data => {
    return request({
        url: `/api-antms/receipt/dispatch/updatecancelarrivedcust`,
        method: 'post',
        data
    });
};

// 运输单明细查询
export const quereyTasKNoArrivalConfirm = data => {
    return request({
        url: `/api-antms/transport/dispatch/quereyTasKNoArrivalConfirm`,
        method: 'post',
        data
    });
};

// 运输单运抵确认
export const updatehandlearrivedcustByTransport = data => {
    return request({
        url: `/api-antms/receipt/dispatch/updatehandlearrivedcustByTransport`,
        method: 'post',
        data
    });
};

// 运输单取消运抵
export const updatecancelarrivedcustByTransport = data => {
    return request({
        url: `/api-antms/receipt/dispatch/updatecancelarrivedcustByTransport`,
        method: 'post',
        data
    });
};

// 位置信息查看接口
export const viewDispatchIotPositionTracePage = data => {
    return request({
        url: `/api-antms/transport/dispatch/viewDispatchIotPositionTracePage`,
        method: 'post',
        data
    });
};

// 明细装车--根据发车单号分页查询运单接口
export const queryLoadCarTransportPage = data => {
    return request({
        url: `/api-antms/transport/transport/queryLoadCarTransportPage`,
        method: 'post',
        data
    });
};

// 明细装车--根据发车单号分页查询运单明细接口
export const queryLoadCarDetailPage = data => {
    return request({
        url: `/api-antms/transport/transport/queryLoadCarDetailPage`,
        method: 'post',
        data
    });
};

// 明细装车--运单装车确认
export const saveTransportLoadInfo = data => {
    return request({
        url: `/api-antms/transport/transport/saveTransportLoadInfo`,
        method: 'post',
        data
    });
};

// 明细装车--明细装车保存
export const saveDetailLoadInfo = data => {
    return request({
        url: `/api-antms/transport/transport/saveDetailLoadInfo`,
        method: 'post',
        data
    });
};

// 合同线路-成本收入场景保存接口
export const createWhitoutzdc = data => {
    return request({
        url: `/api-antms/transport/dispatch/iflow/create/whitoutzdc`,
        method: 'post',
        data
    });
};

// 成本审批
export const createZdc = data => {
    return request({
        url: `/api-antms/transport/dispatch/iflow/create/zdc`,
        method: 'post',
        data
    });
};

// 成本校验
export const lsrmCostVerification = data => {
    return request({
        url: `/api-antms/transport/lsrm/costVerification`,
        method: 'post',
        data
    });
};

// 发车单整车装车确认
export const saveDispatchLoadInfo = data => {
    return request({
        url: `/api-antms/transport/transport/saveDispatchLoadInfo`,
        method: 'post',
        data
    });
};

// 设备绑定接口
export const bindEquipment = data => {
    return request({
        url: `/api-antms/transport/dispatch/bindEquipment`,
        method: 'post',
        data
    });
};

// 设备解除绑定接口
export const cancelEquipment = data => {
    return request({
        url: `/api-antms/transport/dispatch/cancelEquipment`,
        method: 'post',
        data
    });
};

// 运输单维度绑定设备-站点查询接口
export const queryBindEquipment = data => {
    return request({
        url: `/api-antms/transport/transport/queryBindEquipment`,
        method: 'get',
        params: data
    });
};

// 运输单维度绑定设备-绑定修改接口
export const bindEquipmentByTransport = data => {
    return request({
        url: `/api-antms/transport/transport/bindEquipment`,
        method: 'post',
        data
    });
};

// 运输单维度绑定设备-取消绑定接口
export const cancelEquipmentByTransport = data => {
    return request({
        url: `/api-antms/transport/transport/cancelEquipment`,
        method: 'post',
        data
    });
};

// 在途编辑保存按钮
export const updateDispatchOntheway = data => {
    return request({
        url: `/api-antms/transport/dispatch/updateDispatchOntheway`,
        method: 'post',
        data
    });
};

// 运输协议---附件分页查询通用接口
export const attachmentPage = data => {
    return request({
        url: `/api-antms/transport/attachment/page`,
        method: 'post',
        data
    });
};

// 运输协议---上传运输协议
export const uploadTransportProtocol = data => {
    return request({
        url: `/api-antms/transport/dispatch/uploadTransportProtocol`,
        method: 'post',
        data
    });
};

// 运输协议---重推运输协议
export const uploadRetryTransportProtocol = data => {
    return request({
        url: `/api-antms/transport/dispatch/uploadRetryTransportProtocol`,
        method: 'post',
        data
    });
};

// 在途登记---在途登记保存接口
export const saveOnWayPositionTrace = data => {
    return request({
        url: `/api-antms/transport/dispatch/saveOnWayPositionTrace`,
        method: 'post',
        data
    });
};

// 在途登记---查询订单信息
export const getTaskData = data => {
    return request({
        url: `/api-antms/transport/transport/list/sort`,
        method: 'get',
        params: data
    });
};

// 在途登记---查询打点记录
export const queryIotPointByDispatchNoAndTaskNo = data => {
    return request({
        url: `/api-antms/transport/iotPoint/queryIotPointByDispatchNoAndTaskNo`,
        method: 'post',
        data
    });
};

// 合同外线路---获取目标成本
export const lsrmCostSearch = data => {
    return request({
        url: `/api-antms/transport/lsrm/costSearch`,
        method: 'post',
        data
    });
};

// 合同线路---厨热场景保存接口
export const iflowCreateKitchen = data => {
    return request({
        url: `/api-antms/transport/dispatch/iflow/create/kitchen`,
        method: 'post',
        data
    });
};

// 合同外线路---获取厨热订单数
export const getKitchenCount = data => {
    return request({
        url: `/api-antms/transport/dispatch/kitchen/count?dispatchNo=${data}`,
        method: 'get'
    });
};

// 零担干线下发---零担干线下发取消
export const lingdanCancleOders = data => {
    return request({
        url: `/api-antms/transport/lingdan/cancleOders`,
        method: 'post',
        data
    });
};

// 零担干线下发---零担干线下发
export const lingdanCreateOnlineOdersANNTO = params => {
    return request({
        url: `/api-antms/transport/lingdan/createOnlineOdersANNTO`,
        method: 'get',
        params
    });
};
// 零担干线下发---零担干线下发
export const pageCreateOnlineOdersANNTO = params => {
    return request({
        url: `/api-antms/transport/lingdan/pageCreateOnlineOdersANNTO`,
        method: 'post',
        data: params
    });
};

// 取消零担干线下发---查询可以取消零担干线下发的运输单
export const lingdanSearchCancleOders = data => {
    return request({
        url: `/api-antms/transport/lingdan/searchCancleOders`,
        method: 'post',
        data
    });
};

// 园区预约--查询装卸货信息列表
export const queryReservationLoadInfo = data => {
    return request({
        url: `/api-antms/transport/transport/queryReservationLoadInfo`,
        method: 'post',
        data
    });
};

// 园区预约--查询预约时间段接口
export const queryReservationTime = data => {
    return request({
        url: `/api-antms/transport/transport/queryReservationTime`,
        method: 'post',
        data
    });
};

// 园区预约--确定
export const reservationConfirm = data => {
    return request({
        url: `/api-antms/transport/transport/reservationConfirm`,
        method: 'post',
        data
    });
};

// 园区预约--更新
export const reservationUpdate = data => {
    return request({
        url: `/api-antms/transport/transport/reservationSync`,
        method: 'post',
        data
    });
};

// 园区预约--取消预约
export const reservationCancel = data => {
    return request({
        url: `/api-antms/transport/transport/reservationCancel `,
        method: 'post',
        data
    });
};

// 发车顺序--查询列表
export const querySequenceList = data => {
    return request({
        url: `/api-antms/transport/transport/wlLoadCar/queryList`,
        method: 'get',
        params: data
    });
};

// 发车顺序--确定
export const updateWlLoadSequence = data => {
    return request({
        url: `/api-antms/transport/transport/updateWlLoadSequence`,
        method: 'post',
        data
    });
};
// 下发零担查询账号接口
export const queryLtlPlatform = data => {
    return request({
        url: `/api-antms/transport/lingdan/queryLtlPlatform`,
        method: 'get',
        params: data
    });
};

// 新增标签接口
export const tabAdd = data => {
    return request({
        url: `/api-antms/common/report/tab/add`,
        method: 'post',
        data
    });
};

// 查询标签接口
export const queryTabList = data => {
    return request({
        url: `/api-antms/common/report/tab/list`,
        method: 'get',
        params: data
    });
};

// 删除标签接口
export const tabRemove = data => {
    return request({
        url: `/api-antms/common/report/tab/remove?id=${data}`,
        method: 'post',
        data
    });
};

// 整车异常发车原因登记接口
export const registerAbnormalDepartReason = data => {
    return request({
        url: `/api-antms/transport/dispatchLcl/registerAbnormalDepartReason`,
        method: 'post',
        data
    });
};

// 运输成本修改保存接口
export const checkNeedStartZdcFlowByCost = data => {
    return request({
        url: `/api-antms/transport/dispatch/checkNeedStartZdcFlowByCost`,
        method: 'post',
        data
    });
};

// 运输成本修改保存接口
export const updateTransportCost = data => {
    return request({
        url: `/api-antms/transport/dispatch/updateTransportCost`,
        method: 'post',
        data
    });
};

// 运输成本修改日志查询接口
export const queryRecord = data => {
    return request({
        url: `api-antms/billing/transportationCostRecord/page/query`,
        method: 'post',
        data
    });
};

// 装车校验接口
export const checkLoadCarSave = data => {
    return request({
        url: `/api-antms/transport/transport/checkLoadCarSave`,
        method: 'post',
        data
    });
};

// 发车重排接口
export const dispatchRearrange = data => {
    return request({
        url: `/api-antms/transport/dispatchLcl/dispatchRearrange`,
        method: 'post',
        data
    });
};

// CP单重算
export const cpRecalculate = data => {
    return request({
        url: `/api-antms/billing/billingAdvance/cpRecalculate`,
        method: 'post',
        data
    });
};

// 车辆改派记录接口
export const queryVehicleRecord = data => {
    return request({
        url: `/api-antms/transport/dispatch/reassign/recordList?dispatchNo=${data}`,
        method: 'post',
        data
    });
};

// 取消装货
export const cancelLoadStatus = dispatchNo => {
    return request({
        url: `/api-antms/transport/transport/cancelLoadStatus?dispatchNo=${dispatchNo}`,
        method: 'get'
    });
};

// 判断发车异常卡控弹框接口
export const isNeedExceptionRemarks = data => {
    return request({
        url: `/api-antms/transport/dispatch/isNeedExceptionRemarks`,
        method: 'post',
        data
    });
};

// 发车异常保存接口
export const addExceptionRemarks = data => {
    return request({
        url: `/api-antms/transport/dispatch/addExceptionRemarks`,
        method: 'post',
        data
    });
};

// 发车人工操作校验接口
export const checkLclOperate = data => {
    return request({
        url: `/api-antms/transport/dispatchLcl/checkLclOperate`,
        method: 'post',
        data
    });
};

// 根据站点到车或抵达人工操作校验接口
export const checkSiteAddressLclOperate = (data) => {
    return request({
        url: `/api-antms/transport/transportLcl/checkSiteAddressLclOperate`,
        method: 'post',
        data
    });
};

// 运输单抵达人工操作校验接口
export const checkTransportLclOperate = (data) => {
    return request({
        url: `/api-antms/transport/transportLcl/checkTransportLclOperate`,
        method: 'post',
        data
    });
};

// 发车操作原因保存接口
export const updateDispatchLclOperateReason = data => {
    return request({
        url: `/api-antms/transport/dispatchLcl/updateDispatchLclOperateReason`,
        method: 'post',
        data
    });
};

// 根据运输单抵达操作原因保存接口
export const updateArrivalOperateReasonByTaskNo = data => {
    return request({
        url: `/api-antms/transport/transportLcl/updateArrivalOperateReasonByTaskNo`,
        method: 'post',
        data
    });
};

// 根据站点到车或抵达操作原因保存接口
export const updateTransportLclArriveOperateReason = data => {
    return request({
        url: `/api-antms/transport/transportLcl/updateTransportLclArriveOperateReason`,
        method: 'post',
        data
    });
};

// 计费前置-试算
export const tryCalculation = data => {
    return request({
        url: `/api-antms/billing/billing/advance/cost/try/calculation`,
        method: 'post',
        data
    });
};

// 日趟数重算
export const rankRecalculate = data => {
    return request({
        url: `/api-antms/billing/billingAdvance/rankRecalculate`,
        method: 'post',
        data
    });
};

// 园区预约 加急、取消加急
export const reservationUrgent = data => {
    return request({
        url: `/api-antms/transport/transport/reservationUrgent`,
        method: 'post',
        data
    });
};

// 发车单操作日志 日志查询
export const queryOperationLog = data => {
    return request({
        url: `/api-antms/query/dispatch/operationLog/queryByPage`,
        method: 'post',
        data
    });
};

// 发车单操作日志 运输单查询接口
export const queryTaskNo = data => {
    return request({
        url: `/api-antms/query/dispatch/operationLog/queryTaskNo`,
        method: 'get',
        params: data
    });
};

// 获取阿波罗配置的最大查询时间区间
export const queryTimeInterval = data => {
    return request({
        url: `/api-antms/query/page/queryTimeInterval`,
        method: 'post',
        data
    });
};
